<template>
  <div>
    <h1>Detail Aplikasi</h1>
    <div v-if="aplikasi">
      <p><strong>Nama:</strong> {{ aplikasi.namaapps }}</p>
      <p><strong>URL:</strong> {{ aplikasi.url }}</p>
      <p><strong>Logo:</strong> {{ aplikasi.logo }}</p>
      <p><strong>Deskripsi:</strong> {{ aplikasi.deskripsi }}</p>
      <p><strong>Bisnis:</strong> {{ aplikasi.bussinesname }}</p>
      <p><strong>Versi:</strong> {{ aplikasi.version }}</p>
    </div>
  </div>
</template>
<script setup>
import { usePage } from "@inertiajs/vue3";
const { aplikasi } = usePage().props;
</script>
